export default __webpack_public_path__ + "static/media/letsencrypt.50422635.svg";